export enum Template {
    DEFAULT = 1,
    CATALOG = 2
}

export enum OptionQuestion {
    SIMPLE = 1,
    MULTIPLE = 2,
    FREE = 3,
    AFFECTIVE = 4,
    CATALOG = 5
}